import { UserTrainingStatistics } from "@models/UserTrainingStatistics";
import { DataTableStatisticDto, Hms } from "components/StatisticsDataTable/Dto/DataTableStatisticDto";
import { RewardType } from "@models/RewardType";

export const convertToStatisticDataTableDto = (data: UserTrainingStatistics[], translation: Record<RewardType, string>) : DataTableStatisticDto[] => {
    if(!data){
        return []
    }

     return data.map((item) => {
        const convertedTimeSpent = parseTime(item.timeSpent);
        return {
        userId: item.userId,
        userDisplayName: item.userDisplayName,
        lessonName: item.lessonName,
        lessonId: item.lessonId,
        userTagA: item.userTagA,
        userTagB: item.userTagB,
        dateCompleted: item.dateCompleted,
        dateStarted: item.createdAt,
        rewardType: translation[item.rewardType],
        timeSpent: item.timeSpent,
        convertedTimeSpent,
        score: {
          maxPoints: item.maxPoints,
          scoredPoints: item.scoredPoints,
        },
        lessonProgressStatus: item.lessonProgressStatus,
        };
  });
}

export const parseTime = (raw: string | null): Hms | null => {
  if (raw == null || raw.trim() === '') {
    return null;
  }

  const src = raw.toLowerCase().trim();

  const unit = (re: RegExp) => {
    const m = src.match(re);
    return m ? Number(m[1].replace(',', '.')) : NaN;
  };

  let h = unit(/(\d+(?:[.,]\d+)?)\s*h/);
  let m = unit(/(\d+(?:[.,]\d+)?)\s*m(?:in)?/);
  let s = unit(/(\d+(?:[.,]\d+)?)\s*s(?:ec(?:onds?)?)?/);

  if (!Number.isFinite(h) || !Number.isFinite(m) || !Number.isFinite(s)) {
    const parts = src.split(':').map(p => p.replace(/[^\d.,-]/g, ''));
    const num = (i: number) => Number((parts[i] ?? '').replace(',', '.'));

    if (!Number.isFinite(s) && parts.length >= 2) s = num(parts.length - 1);
    if (!Number.isFinite(m)) {
      if (parts.length === 3) m = num(1);
      if (parts.length === 2) m = num(0);
    }
    if (!Number.isFinite(h) && parts.length === 3) h = num(0);
  }

  return {
    h: Number.isFinite(h) ? Math.trunc(h) : 0,
    m: Number.isFinite(m) ? Math.trunc(m) : 0,
    s: Number.isFinite(s) ? Math.trunc(s) : 0,
  };
};

export const convertTimeToMiuntes = (time: Hms): number => {
  return time.h * 60 + time.m + time.s / 60;
}